module.exports = __webpack_public_path__ + "img/7534a76c5a021a6aae2f7fa0dc8e237c.ttf";